import React, { Fragment, useState } from 'react';
import { Link } from 'react-router-dom'
import Header from '../../components/header/Header';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import ModalVideo from 'react-modal-video'
import CtaSection from '../../components/CtaSection/CtaSection';
import PolicySection from './Policy';
import offerBanner from '../../images/icons/best_offer.svg.svg';
import PartnerSection from '../../components/PartnerSection';
import Journey from '../../components/journey/journey';


const PricingPage = (props) => {

    const [isOpen, setOpen] = useState(false)

    const [isActive, setIsActive] = useState(false);

    const handleToggle = () => {
        setIsActive(!isActive);
    };


    return (
        <Fragment>
            <Header />
            <main className="page_content about-page">
                {/* <PageTitle pageTitle={'Pricing Plan'} pagesub={'Pricing 😍'} pageTop={'Our'} /> */}
                {/* <PolicySection /> */}
                <section className="pricing_section section_space">
                    <div className="container">
                        <div className="heading_block text-center">
                            {/* <div className="heading_focus_text mb-2">
                                Our
                                <span className="badge bg-secondary text-white">Pricing 😍</span>
                            </div> */}
                            <h2 className="heading_text mb-0">
                                Plans & Pricing
                            </h2>
                        </div>
                        <div className="pricing_toggle_btn text-center">
                            <button type="button" onClick={handleToggle} className={isActive ? 'active' : ''}>
                                <span>Monthly</span>
                                <span>Annually</span>
                            </button>
                        </div>
                        <div className="row justify-content-center">
                            <div className="col-lg-4">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>

                                    <h3 className="pricing_package_title">Basic Plan</h3>
                                    <h2>599 <span class="price1_css">INR/month</span></h2>

                                    <ul className="icon_list unordered_list_block price_list pricing_annually">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Software Development.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Digital Product Design
                                            </span>
                                        </li>
                                    </ul>

                                    <ul className="icon_list unordered_list_block price_list pricing_monthly">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Software Development.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Digital Product Design
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                IT Consulting.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Website Development.
                                            </span>
                                        </li>
                                    </ul>

                                    <div className='text-center'>
                                       <Link to="/pricing" className='buy_now'>BUY NOW</Link>
                                    </div>

                                </div>
                            </div>
                            
                            <div className="col-lg-4">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>

                                    <h3 className="pricing_package_title">Pro Plan</h3>
                                    <h2>999 <span class="price1_css">INR/month</span></h2>
                                    <ul className="icon_list unordered_list_block price_list pricing_annually">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Software Development.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Digital Product Design
                                            </span>
                                        </li>
                                    </ul>

                                    <ul className="icon_list unordered_list_block price_list pricing_monthly">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Software Development.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Digital Product Design
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                IT Consulting.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Website Development.
                                            </span>
                                        </li>
                                    </ul>

                                    <div className='text-center'>
                                       <Link to="/pricing" className='buy_now'>BUY NOW</Link>
                                    </div>

                                </div>
                            </div>

                            <div className="col-lg-4">
                                <div className={`pricing_block ${isActive ? 'active' : ''}`}>

                                    <h3 className="pricing_package_title">Business Plan</h3>
                                    <h2>1499 <span class="price1_css">INR/month</span></h2>

                                    <ul className="icon_list unordered_list_block price_list pricing_annually">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Software Development.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Digital Product Design
                                            </span>
                                        </li>
                                    </ul>

                                    <ul className="icon_list unordered_list_block price_list pricing_monthly">
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Software Development.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Digital Product Design
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                IT Consulting.
                                            </span>
                                        </li>
                                        <li>
                                            <span className="icon_list_icon">
                                                <i className="fa-regular fa-circle-check"></i>
                                            </span>
                                            <span className="icon_list_text">
                                                Website Development.
                                            </span>
                                        </li>
                                    </ul>

                                    <div className='text-center'>
                                       <Link to="/pricing" className='buy_now'>BUY NOW</Link>
                                    </div>

                                </div>
                            </div>

                            
                        </div>
                    </div>
                </section>
                <div className="price_section section_space">
                    <div className="container">
                        <div className='row'>
                                <div className='col-lg-8'>
                                    <h2>Need an Enterprise Solution?</h2>
                                    <p>We offer customizable solutions for large teams <br/> and companies. Get in touch with us to know more.</p>
                                    <Link to="/pricing" className='learn_more'>Contact Sales</Link>
                                </div>
                                <div className='col-lg-4'>
                                    <ul className=''>
                                        <li>Volume discounts</li>
                                        <li>More GPT-4o words</li>
                                        <li>More plagiarism check words</li>
                                        <li>Customized features</li>
                                        <li>Ongoing tech support</li>
                                    </ul>
                                </div>
                        </div>
                    </div>
                </div>


                <div className="section_space pb-0">
                    <h3 className='text-center'>Add-Ons (Charged separately)</h3>

                    <div className='addon_section section_space'>
                        <div className='container'>
                                <div className='row'>
                                    <div className='price_block'>
                                        <div className='col-lg-3 col-md-12'>
                                        <h2>999 <span className='price1_css'>Rs</span> <span className='price3_css'>Month</span></h2>
                                        <Link to="/pricing" className='learn_more'>Buy Now</Link>
                                        </div>
                                        <div className='col-lg-2 col-md-12'>
                                            
                                        </div>
                                        <div className='col-lg-7 col-md-12 text-right'>
                                            <h4>HR Management/ Employee management</h4>
                                            <p>We offer customizable solutions for large teams <br/> and companies. Get in touch with us to know more.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='price_block'>
                                        <div className='col-lg-3 col-md-12'>
                                        <h2>1500 <span className='price1_css'>Rs</span> <span className='price3_css'>Month</span></h2>
                                        <Link to="/pricing" className='learn_more'>Buy Now</Link>
                                        </div>
                                        <div className='col-lg-2 col-md-12'>
                                            
                                        </div>
                                        <div className='col-lg-7 col-md-12 text-right'>
                                            <h4>Channel Manager (OTA)</h4>
                                            <p>We offer customizable solutions for large teams <br/> and companies. Get in touch with us to know more.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='price_block'>
                                        <div className='col-lg-3 col-md-12'>
                                        <h2>499 <span className='price1_css'>Rs</span> <span className='price3_css'>Month</span></h2>
                                        <Link to="/pricing" className='learn_more'>Buy Now</Link>
                                        </div>
                                        <div className='col-lg-2 col-md-12'>
                                            
                                        </div>
                                        <div className='col-lg-7 col-md-12 text-right'>
                                            <h4>Restaurant and Dining Management System</h4>
                                            <p>We offer customizable solutions for large teams <br/> and companies. Get in touch with us to know more.</p>
                                        </div>
                                    </div>
                                </div>

                                <div className='row'>
                                    <div className='price_block'>
                                        <div className='col-lg-3 col-md-12'>
                                        <h2>250 <span className='price1_css'>Rs</span> <span className='price3_css'>Month</span></h2>
                                        <Link to="/pricing" className='learn_more'>Buy Now</Link>
                                        </div>
                                        <div className='col-lg-2 col-md-12'>
                                            
                                        </div>
                                        <div className='col-lg-7 col-md-12 text-right'>
                                            <h4>Option to add Rooms and users</h4>
                                            <p>We offer customizable solutions for large teams <br/> and companies. Get in touch with us to know more.</p>
                                        </div>
                                    </div>
                                </div>



                        </div>
                    </div>
                </div>

                <Journey />

            </main>
            {/* <CtaSection /> */}
            <Footer />
            <Scrollbar />
        </Fragment>
    )
};
export default PricingPage;
